(function () {
    'use strict';

    function main() {

        var controller = {
            init: function () {
                WhistleOut.getAds('MobilePhones');
            }
        };

        controller.init();
    };

    WhistleOut.initModule(import.meta.url, main);

}());